import React from "react";
import { connect } from "react-redux";
import styled from "@emotion/styled";
import {
  getMerchantArray,
  getCurrentSearch,
  getCategoryMerchantArray
} from "@modules/NewBuy/selector";
import loadable from "@loadable/component";
const MessageContainer = loadable(() =>
  import(/* webpackChunkName: "MessageContainer" */ "./MessageContainer")
);
const Container = styled.p`
  margin: 0;
`;

const BrandsFound = ({ getMerchantArraySelector }) => (
  <Container>
    {getMerchantArraySelector && (
      <>{getMerchantArraySelector.length} brands found</>
    )}
  </Container>
);

const Message = ({ currentSearch, getMerchantArraySelector }) => (
  <>
    {currentSearch &&
      getMerchantArraySelector &&
      getMerchantArraySelector.length < 1 && (
        <MessageContainer
          classes={"discount-buy-error-message"}
          message={`Sorry, no cards match this search.`}
          icon={"https://cdn.cardcash.com/website/ui/elements/error-icon.svg"}
        />
      )}
  </>
);

const connected = elem =>
  connect(state => ({
    currentSearch: getCurrentSearch({
      currentSearch: state.userActions.buySearchText
    }),
    getMerchantArraySelector: !state.userActions.selectedCategory
      ? getMerchantArray({
          merchantArray: state.merchantsNew.sortedByName,
          currentSearch: state.userActions.buySearchText,
          filterCards: state.userActions.filterCards
        })
      : getCategoryMerchantArray({
          merchantArray: state.merchantsNew.sortedByName,
          currentSearch: state.userActions.buySearchText,
          filterCards: state.userActions.filterCards,
          categories: state.categories.allCategories,
          categoryName: state.userActions.selectedCategory
        })
  }))(elem);

export const NewBrands = connected(BrandsFound);
export const MessageErr = connected(Message);
